module.exports = __webpack_public_path__ + "img/facebook.5ed24d10.svg";